export const authHeader = () => {
    return { 'access-token': localStorage.getItem('token') };
}